import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { inject, observer } from 'mobx-react';
import React, { useContext } from "react";
import { compose } from 'recompose';
import AuthContext from '../auth-context';

const PhoneNumber = (props) => {
  const authStore = useContext(AuthContext)

  let number = props.number === undefined || props.number === null || props.number === '' ? '-' : props.number
  const phoneNumber = parsePhoneNumberFromString(number, 'AU')
  const voice = authStore.hasRole('voice_enabled')
  const validNumber = phoneNumber && phoneNumber.isValid()
  const displayNumber = validNumber ? phoneNumber.formatNational() : number
  return (
    <span>
      <span>{validNumber && voice ? <button className='button-link' onClick={(e) => { e.preventDefault(); props.dialerStore.addNumberToCall(phoneNumber.formatNational()) }}>{displayNumber}</button> : <span style={{whiteSpace: 'nowrap'}}>{number}</span>}</span>
    </span>
  )
}

export default compose(inject('dialerStore'))(observer(PhoneNumber))